// extracted by mini-css-extract-plugin
export default {"device":"computer_device__ZloXN","screen":"computer_screen__PnAC+","iframe":"computer_iframe__Rb3MW","stand":"computer_stand__wmAfA","base":"computer_base__XqiA7"};